var map = {
	"./en": [
		1319,
		319
	],
	"./en.ts": [
		1319,
		319
	],
	"./pl": [
		1711,
		711
	],
	"./pl.ts": [
		1711,
		711
	],
	"./ru": [
		7285,
		285
	],
	"./ru.ts": [
		7285,
		285
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9904;
module.exports = webpackAsyncContext;